import React from 'react';

/**
 * A compatibility wrapper for useTransition. When the running React build
 * provides useTransition (React 18+) it is used directly; otherwise it falls
 * back to a no-op startTransition that executes callbacks immediately.
 *
 * @returns {[boolean, function]} - [isPending, startTransition]
 */
export const useTransition = () => {
  if (typeof React.useTransition === 'function') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return React.useTransition();
  }

  const startTransition = callback => {
    callback();
  };

  return [false, startTransition];
};

/**
 * A compatibility wrapper for useDeferredValue. When the running React build
 * provides useDeferredValue (React 18+) it is used directly; otherwise the
 * value is returned unchanged (no deferral).
 *
 * @param {any} value - The value to defer
 * @returns {any} - The deferred value (or the same value when unsupported)
 */
export const useDeferredValue = value => {
  if (typeof React.useDeferredValue === 'function') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return React.useDeferredValue(value);
  }

  return value;
};
